import {
  Dialog,
  DialogContent,
  DialogDescription,
  DialogFooter,
  DialogHeader,
  DialogTitle,
  DialogTrigger,
} from '@/components/ui/dialog';
import { Button } from '../button';

const ConfirmDialog = ({
  onConfirm,
  dialogIsOpen,
  onOpen,
  onClose,
  children,
  title,
  description,
}: {
  onConfirm: () => void;
  dialogIsOpen: boolean;
  onOpen: () => void;
  onClose: () => void;
  children?: React.ReactNode;
  title: string;
  description: string;
}) => {
  return (
    <Dialog
      open={dialogIsOpen}
      // DEV NOTE: without modal `false` the dialog will make the entire page unresponsive
      // this is a known issue with shadcn/ui
      // See: https://github.com/shadcn-ui/ui/issues/1912
      modal={false}
    >
      <DialogTrigger asChild onClick={onOpen}>
        {children || null}
      </DialogTrigger>
      <DialogContent className="sm:max-w-[425px]" onClickClose={onClose}>
        <DialogHeader>
          <DialogTitle>{title}</DialogTitle>
          <DialogDescription>{description}</DialogDescription>
        </DialogHeader>

        <DialogFooter>
          <Button variant="secondary" type="reset" onClick={onClose}>
            Cancel
          </Button>
          <Button variant="default" type="reset" onClick={onConfirm}>
            Confirm
          </Button>
        </DialogFooter>
      </DialogContent>
    </Dialog>
  );
};

export default ConfirmDialog;
